// var swiper1 = new Swiper(".clHeroBannerSlider", {
//   grabCursor: true,
//   speed: 500,
//   effect: "fade",
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   fadeEffect: {
//     crossFade: true,
//   },
// });
// var swiper2 = new Swiper(".clHeroBannerTwoSlider-content", {
//   effect: "cards",
//   grabCursor: true,
//   cardsEffect: {
//     perSlideOffset: 1,
//     perSlideRotate: 1,
//     slideShadows: false,
//   },
// });
// swiper1.on('slideChange', function () {
//   swiper2.slideTo(swiper1.activeIndex);
// });
// swiper2.on('slideChange', function () {
//   swiper1.slideTo(swiper2.activeIndex);
// });
// let syncing = false;

// const swiper1 = new Swiper(".clHeroBannerSlider", {
//   grabCursor: true,
//   speed: 500,
//   effect: "fade",
//   loop: true,
//   navigation: {
//     nextEl: ".hero-next",
//     prevEl: ".hero-prev",
//   },
//   fadeEffect: {
//     crossFade: true,
//   },
// });

// const swiper2 = new Swiper(".clHeroBannerTwoSlider-content", {
//   effect: "cards",
//   grabCursor: true,
//   loop: true,
//   cardsEffect: {
//     perSlideOffset: 1,
//     perSlideRotate: 1,
//     slideShadows: false,
//   },
// });

// // Sync swiper1 → swiper2
// swiper1.on("realIndexChange", () => {
//   if (syncing) return;
//   syncing = true;
//   swiper2.slideToLoop(swiper1.realIndex);
//   setTimeout(() => syncing = false, 100);
// });

// // Sync swiper2 → swiper1
// swiper2.on("realIndexChange", () => {
//   if (syncing) return;
//   syncing = true;
//   swiper1.slideToLoop(swiper2.realIndex);
//   setTimeout(() => syncing = false, 100);
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.speaker', function(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     var $bannerBox = $(this).closest('.clBannerVideoBox');
//     var $video = $bannerBox.find('video').get(0);
//     $bannerBox.toggleClass('active');
//     if ($bannerBox.hasClass('active')) {
//         if ($video) $video.muted = false;
//     } else {
//         if ($video) $video.muted = true;
//     }
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox video', function() {
//     var $bannerBox = $(this).closest('.clBannerVideoBox');
//     var $video = $bannerBox.find('video').get(0);

//     if ($video) {
//         if ($video.paused) {
//             $video.play();
//             $bannerBox.removeClass('pause');
//         } else {
//             $video.pause();
//             $bannerBox.addClass('pause');
//         }
//     }
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.speaker', function(e){
//     e.preventDefault();
//     e.stopPropagation();
//     var $box=$(this).closest('.clBannerVideoBox');
//     var $video=$box.find('video').get(0);
//     var $iframe=$box.find('iframe').get(0);
//     $box.toggleClass('active');
//     if($box.hasClass('active')){
//         if($video) $video.muted=false;
//         if($iframe) $iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
//     }else{
//         if($video) $video.muted=true;
//         if($iframe) $iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
//     }
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center', function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     var $video=$box.find('video').get(0);
//     var $iframe=$box.find('iframe').get(0);
//     if($video){
//         if($video.paused){
//             $video.play();
//             $box.removeClass('pause');
//         }else{
//             $video.pause();
//             $box.addClass('pause');
//         }
//     }
//     if($iframe){
//         var func=$box.hasClass('pause')?'playVideo':'pauseVideo';
//         $iframe.contentWindow.postMessage('{"event":"command","func":"'+func+'","args":""}', '*');
//         $box.toggleClass('pause');
//     }
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk', function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();
//     $box.find('span.pause-desk-center').show();
// });

// $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center', function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();
//     $box.find('span.pause-desk').show();
// });

// function initHeroBanner(){
//   let syncing=false;

//   const swiper1=new Swiper(".clHeroBannerSlider",{
//     grabCursor:true,
//     speed:500,
//     effect:"fade",
//     loop:true,
//     navigation:{nextEl:".hero-next",prevEl:".hero-prev"},
//     fadeEffect:{crossFade:true},
//   });

//   const swiper2=new Swiper(".clHeroBannerTwoSlider-content",{
//     effect:"cards",
//     grabCursor:true,
//     loop:true,
//     cardsEffect:{perSlideOffset:1,perSlideRotate:1,slideShadows:false},
//   });

//   swiper1.on("realIndexChange",()=>{
//     if(syncing)return;
//     syncing=true;
//     swiper2.slideToLoop(swiper1.realIndex);
//     setTimeout(()=>syncing=false,100);
//   });

//   swiper2.on("realIndexChange",()=>{
//     if(syncing)return;
//     syncing=true;
//     swiper1.slideToLoop(swiper2.realIndex);
//     setTimeout(()=>syncing=false,100);
//   });

//   $(document).on('click','.hero-next, .hero-prev',function(){
//     $(this).removeClass('swiper-button-disabled swiper-button-lock');
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.speaker',function(e){
//     e.preventDefault();
//     e.stopPropagation();
//     var $box=$(this).closest('.clBannerVideoBox');
//     var $video=$box.find('video').get(0);
//     var $iframe=$box.find('iframe').get(0);
//     $box.toggleClass('active');
//     if($box.hasClass('active')){
//       if($video)$video.muted=false;
//       if($iframe)$iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}','*');
//     }else{
//       if($video)$video.muted=true;
//       if($iframe)$iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}','*');
//     }
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center',function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     var $video=$box.find('video').get(0);
//     var $iframe=$box.find('iframe').get(0);
//     if($video){
//       if($video.paused){
//         $video.play();
//         $box.removeClass('pause');
//       }else{
//         $video.pause();
//         $box.addClass('pause');
//       }
//     }
//     if($iframe){
//       var func=$box.hasClass('pause')?'playVideo':'pauseVideo';
//       $iframe.contentWindow.postMessage('{"event":"command","func":"'+func+'","args":""}','*');
//       $box.toggleClass('pause');
//     }
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk',function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();
//     $box.find('span.pause-desk-center').show();
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center',function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();
//     $box.find('span.pause-desk').show();
//   });

//   setTimeout(()=>{
//     $('section.clHeroBanner .swiperBtnWrapper .swiperBtn').removeClass('swiper-button-lock swiper-button-disabled');
//   },100);
// }
// initHeroBanner();

// function initHeroBanner(){
//   let syncing=false;

//   const swiper1=new Swiper(".clHeroBannerSlider",{grabCursor:true,speed:500,effect:"fade",loop:true,navigation:{nextEl:".hero-next",prevEl:".hero-prev"},fadeEffect:{crossFade:true}});
//   const swiper2=new Swiper(".clHeroBannerTwoSlider-content",{effect:"cards",grabCursor:true,loop:true,cardsEffect:{perSlideOffset:1,perSlideRotate:1,slideShadows:false}});

//   swiper1.on("realIndexChange",()=>{if(syncing)return;syncing=true;swiper2.slideToLoop(swiper1.realIndex);setTimeout(()=>syncing=false,100)});
//   swiper2.on("realIndexChange",()=>{if(syncing)return;syncing=true;swiper1.slideToLoop(swiper2.realIndex);setTimeout(()=>syncing=false,100)});

//   $(document).on('click','.hero-next, .hero-prev',function(){$(this).removeClass('swiper-button-disabled swiper-button-lock')});

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.speaker',function(e){
//     e.preventDefault();e.stopPropagation();
//     var $box=$(this).closest('.clBannerVideoBox'),$video=$box.find('video').get(0),$iframe=$box.find('iframe').get(0);
//     $box.toggleClass('active');
//     if($box.hasClass('active')){
//       if($video)$video.muted=false;
//       if($iframe){
//         if($($iframe).attr('src').includes('youtube'))$iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}','*');
//         if($($iframe).attr('src').includes('vimeo'))$iframe.contentWindow.postMessage('{"method":"setVolume","value":1}','*');
//       }
//     }else{
//       if($video)$video.muted=true;
//       if($iframe){
//         if($($iframe).attr('src').includes('youtube'))$iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}','*');
//         if($($iframe).attr('src').includes('vimeo'))$iframe.contentWindow.postMessage('{"method":"setVolume","value":0}','*');
//       }
//     }
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center',function(){
//     var $box=$(this).closest('.clBannerVideoBox'),$video=$box.find('video').get(0),$iframe=$box.find('iframe').get(0);
//     if($video){if($video.paused){$video.play();$box.removeClass('pause')}else{$video.pause();$box.addClass('pause')}}
//     if($iframe){
//       if($($iframe).attr('src').includes('youtube')){
//         var func=$box.hasClass('pause')?'playVideo':'pauseVideo';
//         $iframe.contentWindow.postMessage('{"event":"command","func":"'+func+'","args":""}','*');
//         $box.toggleClass('pause');
//       }
//       if($($iframe).attr('src').includes('vimeo')){
//         var method=$box.hasClass('pause')?'play':'pause';
//         $iframe.contentWindow.postMessage('{"method":"'+method+'"}','*');
//         $box.toggleClass('pause');
//       }
//     }
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk',function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();$box.find('span.pause-desk-center').show();
//   });

//   $(document).on('click','section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center',function(){
//     var $box=$(this).closest('.clBannerVideoBox');
//     $(this).hide();$box.find('span.pause-desk').show();
//   });

//   setTimeout(()=>{$('section.clHeroBanner .swiperBtnWrapper .swiperBtn').removeClass('swiper-button-lock swiper-button-disabled')},100);
// }
// initHeroBanner();
function initHeroBanner() {
  let syncing = false;
  let isInitial = true;

  const swiper1 = new Swiper(".clHeroBannerSlider", {
    grabCursor: true,
    speed: 500,
    effect: "fade",
    loop: true,
    navigation: {
      nextEl: ".hero-next",
      prevEl: ".hero-prev"
    },
    fadeEffect: {
      crossFade: true
    }
  });

  // const swiper2 = new Swiper(".clHeroBannerTwoSlider-content", {
  //   effect: "cards",
  //   grabCursor: true,
  //   loop: true,
  //   cardsEffect: {
  //     perSlideOffset: 1,
  //     perSlideRotate: 1,
  //     slideShadows: false
  //   }
  // });
  const swiper2 = new Swiper(".clHeroBannerTwoSlider-content", {
    effect: "cards",
    grabCursor: true,
    loop: false,
    cardsEffect: {
      perSlideOffset: 1,
      perSlideRotate: 1,
      slideShadows: false
    }
  });


  swiper1.on("realIndexChange", () => {
    if (syncing) return;
    syncing = true;
    if (isInitial) {
      isInitial = false;
      swiper2.slideToLoop(swiper1.realIndex, 0);
    } else {
      swiper2.slideToLoop(swiper1.realIndex);
    }
    setTimeout(() => syncing = false, 100);
  });

  swiper2.on("realIndexChange", () => {
    if (syncing) return;
    syncing = true;
    swiper1.slideToLoop(swiper2.realIndex);
    setTimeout(() => syncing = false, 100);
  });

  // Initialize synchronization
  swiper2.slideToLoop(swiper1.realIndex, 0);

  $(document).on('click', '.hero-next, .hero-prev', function() {
    $(this).removeClass('swiper-button-disabled swiper-button-lock');
    isInitial = false;
  });

  $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.speaker', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $box = $(this).closest('.clBannerVideoBox'),
      $video = $box.find('video').get(0),
      $iframe = $box.find('iframe').get(0);
    $box.toggleClass('active');
    if ($box.hasClass('active')) {
      if ($video) $video.muted = false;
      if ($iframe) {
        if ($($iframe).attr('src').includes('youtube')) $iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
        if ($($iframe).attr('src').includes('vimeo')) $iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
      }
    } else {
      if ($video) $video.muted = true;
      if ($iframe) {
        if ($($iframe).attr('src').includes('youtube')) $iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
        if ($($iframe).attr('src').includes('vimeo')) $iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
      }
    }
  });

  $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk, section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center', function() {
    var $box = $(this).closest('.clBannerVideoBox'),
      $video = $box.find('video').get(0),
      $iframe = $box.find('iframe').get(0);
    if ($video) {
      if ($video.paused) {
        $video.play();
        $box.removeClass('pause');
      } else {
        $video.pause();
        $box.addClass('pause');
      }
    }
    if ($iframe) {
      if ($($iframe).attr('src').includes('youtube')) {
        var func = $box.hasClass('pause') ? 'playVideo' : 'pauseVideo';
        $iframe.contentWindow.postMessage('{"event":"command","func":"' + func + '","args":""}', '*');
        $box.toggleClass('pause');
      }
      if ($($iframe).attr('src').includes('vimeo')) {
        var method = $box.hasClass('pause') ? 'play' : 'pause';
        $iframe.contentWindow.postMessage('{"method":"' + method + '"}', '*');
        $box.toggleClass('pause');
      }
    }
  });

  $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk', function() {
    var $box = $(this).closest('.clBannerVideoBox');
    $(this).hide();
    $box.find('span.pause-desk-center').show();
  });

  $(document).on('click', 'section.clHeroBanner .clHeroBannerTwoSlider .clBannerVideoBox span.pause-desk-center', function() {
    var $box = $(this).closest('.clBannerVideoBox');
    $(this).hide();
    $box.find('span.pause-desk').show();
  });

  setTimeout(() => {
    $('section.clHeroBanner .swiperBtnWrapper .swiperBtn').removeClass('swiper-button-lock swiper-button-disabled');
  }, 100);
}

// Initialize after DOM is fully loaded
$(document).ready(function() {
  initHeroBanner();
});